import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { useSelector } from "react-redux";
import { store } from "../../store/store";

const baseUrl = process.env.REACT_APP_base_URL;

const MoveDocument = createApi({
    reducerPath: 'moveDocument',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers) => {
            // const token = useSelector((state)=> state.user.token)
            const token = store.getState().user.token;
            if (token) {
              headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        MoveDocument: builder.mutation({
            query: ({movedFolderId , selectedFolderId , userId}) => ({
                url: `drive/document-move/${movedFolderId}`, // Replace with your API endpoint URL
                method: 'POST',
                body: { 
                   newParentId: selectedFolderId,
                   owner_id:userId,
            },
            }),
            transformResponse: (response) => {
                return response;
            },
        }),
    }),
});

export const { useMoveDocumentMutation } = MoveDocument;
export default MoveDocument;
